import { render, staticRenderFns } from "./VitaminFactorBandList.vue?vue&type=template&id=b0f655f2&scoped=true"
import script from "./VitaminFactorBandList.vue?vue&type=script&lang=js"
export * from "./VitaminFactorBandList.vue?vue&type=script&lang=js"
import style0 from "./VitaminFactorBandList.vue?vue&type=style&index=0&id=b0f655f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f655f2",
  null
  
)

export default component.exports